import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=28864b70&scoped=true"
import script from "./downloadApp.vue?vue&type=script&lang=js"
export * from "./downloadApp.vue?vue&type=script&lang=js"
import style0 from "./downloadApp.vue?vue&type=style&index=0&id=28864b70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28864b70",
  null
  
)

export default component.exports